// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Integrations .integrations-container {
  padding: 24px;
  max-width: 1200px;
}
.Integrations .integration-card {
  transition: transform 0.2s, box-shadow 0.2s;
}
.Integrations .integration-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/views/UserProfile/components/Integrations/style.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,iBAAA;AAAJ;AAGE;EACE,2CAAA;AADJ;AAGI;EACE,2BAAA;EACA,yCAAA;AADN","sourcesContent":[".Integrations {\n  .integrations-container {\n    padding: 24px;\n    max-width: 1200px;\n  }\n\n  .integration-card {\n    transition: transform 0.2s, box-shadow 0.2s;\n\n    &:hover {\n      transform: translateY(-4px);\n      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
